import moment from 'moment';

class FixedFeeBasisModalController {
  constructor($scope, $uibModalInstance) {
    'ngInject';

    $scope.fixedFeeBasis = {
      contractId: $uibModalInstance.contractId,
      laborCategoryId: 0,
      laborCategoryName: '',
      modLabel: 'Initial',
      weightedDirectLaborRate: 0.0,
      fullyLoadedLaborRate: 0.0,
      fixedFeePerHour: 0.0,
      maxRate: 0.0,
      effectiveDate: null
    };

    $scope.effectiveDateText = '';
    $scope.selectedLaborCategory = {};
    $scope.selectedPeriodOfPerformance = $uibModalInstance.selectedPeriodOfPerformance || null;
    $scope.laborCategories = $uibModalInstance.laborCategories || [];
    $scope.errorMessage = '';
    $scope.existingBasisKeys = {};

    ($uibModalInstance.existingFixedFeeBasis || []).forEach(function (row) {
      $scope.existingBasisKeys[row.periodOfPerformanceId + ':' + row.laborCategoryId] = true;
    });

    if ($scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.startDate) {
      $scope.fixedFeeBasis.effectiveDate = $scope.selectedPeriodOfPerformance.startDate;
      $scope.effectiveDateText = moment($scope.selectedPeriodOfPerformance.startDate).format('MMM DD, YYYY');
    }

    $scope.hasExistingBasis = function (popId, laborCategoryId) {
      return !!$scope.existingBasisKeys[popId + ':' + laborCategoryId];
    };

    $scope.getLaborCategoryOptions = function () {
      const popId = $scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.id;
      if (!popId) {
        return [];
      }
      return $scope.laborCategories.filter(function (lcat) {
        return !$scope.hasExistingBasis(popId, lcat.id);
      });
    };

    $scope.combinationAlreadyExists = function () {
      const pop = $scope.selectedPeriodOfPerformance;
      const lcat = $scope.selectedLaborCategory;
      if (!pop || !pop.id || !lcat || !lcat.id) {
        return false;
      }
      return $scope.hasExistingBasis(pop.id, lcat.id);
    };

    $scope.hasAvailableCombinations = function () {
      return $scope.getLaborCategoryOptions().length > 0;
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.onEffectiveDateSelected = function (selectedDate) {
      const parsed = moment(selectedDate);
      if (!parsed.isValid()) {
        return;
      }
      $scope.fixedFeeBasis.effectiveDate = parsed.format('YYYY-MM-DD');
      $scope.effectiveDateText = parsed.format('MMM DD, YYYY');
    };

    $scope.onEffectiveDateTextChange = function () {
      if (!$scope.effectiveDateText || !$scope.effectiveDateText.trim()) {
        $scope.fixedFeeBasis.effectiveDate = null;
        return;
      }
      const parsed = moment($scope.effectiveDateText, ['MMM DD, YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY'], true);
      if (parsed.isValid()) {
        $scope.fixedFeeBasis.effectiveDate = parsed.format('YYYY-MM-DD');
        $scope.effectiveDateText = parsed.format('MMM DD, YYYY');
      }
    };

    $scope.addFixedFeeBasisEntry = function () {
      if ($scope.combinationAlreadyExists()) {
        $scope.errorMessage = 'A fee basis already exists for this labor category and option year. Use Add Mod on the Fee Basis tab instead.';
        return;
      }

      $scope.fixedFeeBasis.laborCategoryId = $scope.selectedLaborCategory.id;
      $scope.fixedFeeBasis.laborCategoryName = $scope.selectedLaborCategory.name;
      $scope.fixedFeeBasis.periodOfPerformanceId = $scope.selectedPeriodOfPerformance.id;
      if (!$scope.fixedFeeBasis.modLabel || !$scope.fixedFeeBasis.modLabel.trim()) {
        $scope.fixedFeeBasis.modLabel = 'Initial';
      }
      $uibModalInstance.close($scope.fixedFeeBasis);
    };

    $scope.missingRequiredValues = function () {
      return !$scope.hasAvailableCombinations()
        || $scope.fixedFeeBasis.weightedDirectLaborRate == null
        || $scope.fixedFeeBasis.fullyLoadedLaborRate == null
        || $scope.fixedFeeBasis.fixedFeePerHour == null
        || $scope.fixedFeeBasis.maxRate == null
        || !$scope.selectedLaborCategory
        || !$scope.selectedLaborCategory.id
        || !$scope.selectedPeriodOfPerformance
        || !$scope.selectedPeriodOfPerformance.id
        || $scope.combinationAlreadyExists();
    };
  }
}

export default FixedFeeBasisModalController;



// WEBPACK FOOTER //
// ./client/common/modals/fixedFeeBasisModal/fixedFeeBasisModal.controller.js